//#region src/index.ts
const MAX_LOGS = 500;
window.logs = [];
function format(args) {
	return args.map((a) => {
		if (typeof a === "string") return a;
		if (a instanceof Error) return `${a.name}: ${a.message}\n${a.stack ?? ""}`;
		try {
			return JSON.stringify(a);
		} catch {
			return String(a);
		}
	}).join(" ");
}
function push(level, message) {
	window.logs.push(`[${level}] ${message}`);
	if (window.logs.length > MAX_LOGS) window.logs.shift();
}
for (const level of ["error"]) {
	const original = console[level].bind(console);
	console[level] = (...args) => {
		push(level, format(args));
		original(...args);
	};
}
window.addEventListener("error", (event) => {
	push("uncaught", `${event.message} @ ${event.filename}:${event.lineno}:${event.colno}`);
});
window.addEventListener("unhandledrejection", (event) => {
	const reason = event.reason;
	push("unhandledrejection", reason instanceof Error ? `${reason.name}: ${reason.message}\n${reason.stack ?? ""}` : format([reason]));
});
//#endregion
export {};

//# sourceMappingURL=index.js.map